import styled from 'styled-components';

import { Box } from '@ovpn-ui/core';
import { media } from '@ovpn-ui/styles';

/**
 * @deprecated
 */
export const FieldRow = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    justify-content: space-between;
    width: 100%;

    ${media.SM`
        flex-direction: column;
    `}
`;
